<div class="password-indicators" role="status" aria-live="polite">
  <div class="indicator-item" [class.is-typing]="isTyping" *ngFor="let rule of passwordRules">
    <i class="pi" [ngClass]="getIconClass(rule.key)"></i>
    <span class="indicator-text" [ngClass]="getTextClass(rule.key)">{{ rule.label }}</span>
  </div>
</div>
